<div class="tw-flex tw-justify-between">
    <h1 mat-dialog-title>
        {{ 'ECMR.pdf_language_dialog.title' | translate }}
    </h1>

    <button
        mat-icon-button
        mat-dialog-close>
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
    </button>
</div>

<div class="tw-mt-5 tw-flex tw-flex-col tw-pr-10">
    <mat-radio-group
        class="tw-flex tw-flex-col"
        [(ngModel)]="language">
        <mat-radio-button
            color="primary"
            value="EN">
            {{ 'ECMR.pdf_language_dialog.english' | translate }}
        </mat-radio-button>
        <mat-radio-button
            class="tw-mt-2"
            color="primary"
            value="ES">
            {{ 'ECMR.pdf_language_dialog.spanish' | translate }}
        </mat-radio-button>
    </mat-radio-group>
</div>

<div
    mat-dialog-actions
    align="end"
    class="tw-mt-5">
    <button
        mat-button
        mat-dialog-close>
        {{ 'ECMR.pdf_language_dialog.cancel' | translate }}
    </button>

    <button
        mat-raised-button
        color="primary"
        class="tw-ml-3"
        cdkFocusInitial
        (click)="download()">
        {{ 'ECMR.pdf_language_dialog.download' | translate }}
    </button>
</div>
